import React from "react"
import { useDispatch } from "react-redux"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

import { sendRequestPasswordChange } from "../../actions/Utils/app"

const sx = {
	dialog: {
		"& .MuiDialog-paper": {
			width: 700,
			maxWidth: 700,
			borderRadius: 2,
			p: "40px",
		},
	},
	closeButton: {
		position: "absolute",
		top: 28,
		right: 28,
		width: 40,
		height: 40,
		color: "text.secondary",
	},
	title: {
		fontWeight: 500,
		fontSize: 20,
		lineHeight: "28px",
		color: "text.primary",
		mb: "20px",
		pr: "44px",
	},
	body: {
		fontSize: 16,
		lineHeight: "24px",
		color: "text.secondary",
		mb: "36px",
		p: 0,
	},
	actions: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		p: 0,
	},
}

const PasswordExpiredDialog = ({ username }) => {
	const dispatch = useDispatch()

	const handleReset = () => {
		if (username) {
			dispatch(sendRequestPasswordChange(username))
		}
		dispatch({ type: "CLEAR_PASSWORD_EXPIRED" })
	}

	const handleClose = () => {
		dispatch({ type: "CLEAR_PASSWORD_EXPIRED" })
	}

	return (
		<Dialog open onClose={handleClose} sx={sx.dialog}>
			<IconButton sx={sx.closeButton} onClick={handleClose} size="small">
				<CloseIcon />
			</IconButton>
			<DialogContent sx={sx.body}>
				<Typography sx={sx.title}>
					Votre mot de passe a expiré
				</Typography>
				<Typography sx={{ fontSize: 16, lineHeight: "24px", color: "text.secondary" }}>
					Pour des raisons de sécurité, votre mot de passe doit être mis à jour tous les 12 mois.
					Nous allons vous envoyer un e-mail pour le réinitialiser.
				</Typography>
			</DialogContent>
			<DialogActions sx={sx.actions} disableSpacing>
				<Button color="primary" onClick={handleClose}>
					Annuler
				</Button>
				<Button color="primary" variant="contained" onClick={handleReset}>
					Réinitialiser mon mot de passe
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default PasswordExpiredDialog
